import { Stack, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import { SectionLabelRow } from "web_myplann/Shared/Components/SectionLabelRow";

type Props = {
	title: string;
	rightAction?: ReactNode;
	gap?: number;
	children: ReactNode;
};

export const InspirationSection: FC<Props> = ({
	title,
	rightAction,
	gap,
	children,
}) => {
	const theme = useTheme();

	return (
		<>
			<SectionLabelRow title={title} rightAction={rightAction} />
			<Stack
				bgcolor={theme.palette.background.paper}
				px={1.6}
				py={1.6}
				gap={gap}
			>
				{children}
			</Stack>
		</>
	);
};
